export enum ViewAsInvestorPermission {
  Forbidden = 0,
  Allowed = 1
}

export namespace ViewAsInvestorPermission {
  export function toString(viewAsInvestorPermission: ViewAsInvestorPermission): string {
    switch (viewAsInvestorPermission) {
      case ViewAsInvestorPermission.Forbidden:
        return 'Not Allowed';
      case ViewAsInvestorPermission.Allowed:
        return 'allowed';
      default:
        return null;
    }
  }

  export function parse(viewAsInvestorPermission: string): ViewAsInvestorPermission {
    return ViewAsInvestorPermission[viewAsInvestorPermission];
  }
}
export default ViewAsInvestorPermission;
